import DeviceManager from '../utils/device-manager';

type TableComparisonType = {
    $tableComparison: HTMLElement|null,
    $headers: NodeListOf<HTMLElement>|null,
    $tableLabel: HTMLElement|null,
    init(): void,
    resizeTable(): void,
    detectBiggestHeaderHeight(): number,
    affectHeightHeader(height: number): void,
    resetHeightHeader(): void,
};

const TableComparison: TableComparisonType = {
    $tableComparison: null,
    $headers: null,
    $tableLabel: null,

    init() : void {
        this.$tableComparison = document.querySelector('.comparison-table');
        if (this.$tableComparison) {
            this.$headers = this.$tableComparison.querySelectorAll('.comparison-table-services .service-header');
            this.$tableLabel = this.$tableComparison.querySelector('.comparison-table-label');
            DeviceManager.addWindowCallback(() => {
                this.resizeTable();
            });
        }
    },

    resizeTable() : void {
        this.resetHeightHeader();
        const biggestHeight = this.detectBiggestHeaderHeight();
        this.affectHeightHeader(biggestHeight);
    },

    detectBiggestHeaderHeight() : number {
        let biggestHeaderHeight = 0;
        this.$headers?.forEach($header => {
            if (biggestHeaderHeight < $header.offsetHeight) {
                biggestHeaderHeight = $header.offsetHeight;
            }
        });
        return biggestHeaderHeight;
    },

    affectHeightHeader(height: number) : void {
        this.$headers?.forEach($header => {
            $header.style.height = `${height}px`;
        });

        if (this.$tableLabel) {
            this.$tableLabel.style.marginTop = `${height}px`;
        }
    },

    resetHeightHeader() : void {
        this.$headers?.forEach($header => {
            $header.style.height = 'auto';
        });
    },
};

export default TableComparison;
